/**
 * Centralized Company Roles Constants
 * Used across the entire application for consistency
 */

// Standard company roles - DO NOT modify without updating all usages
export const COMPANY_ROLES = [
  { id: 'developer', label: 'Developer', labelAr: 'مطور' },
  { id: 'contractor', label: 'Contractor', labelAr: 'مقاول' },
  { id: 'consultant', label: 'Consultant', labelAr: 'استشاري' },
  { id: 'supplier', label: 'Supplier', labelAr: 'مورد' },
  { id: 'others', label: 'Others', labelAr: 'أخرى' }
];

// Role colors for badges and UI elements
export const ROLE_COLORS = {
  developer: 'bg-purple-500/10 text-purple-500 border-purple-500/30',
  contractor: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/30',
  consultant: 'bg-blue-500/10 text-blue-500 border-blue-500/30',
  supplier: 'bg-amber-500/10 text-amber-500 border-amber-500/30',
  others: 'bg-gray-500/10 text-gray-500 border-gray-500/30'
};

// Helper to get role label
export const getRoleLabel = (roleId, language = 'en') => {
  const role = COMPANY_ROLES.find(r => r.id === roleId);
  if (!role) return roleId;
  return language === 'ar' ? role.labelAr : role.label;
};

// Helper to check if role is valid
export const isValidRole = (roleId) => {
  return COMPANY_ROLES.some(r => r.id === roleId);
};
